// type definition to make Segment script type compatible
declare global {
  interface Window {
    analytics?: any;
  }
}

export function initSegmentAnalytics(analyticsKey: string) {
  if (typeof window === 'undefined') return;
  const analytics = (window.analytics = window.analytics || []);
  if (!analytics.initialize) {
    if (analytics.invoked) {
      window.console &&
        console.error &&
        console.error('Segment snippet included twice.');
    } else {
      analytics.invoked = true;
      analytics.methods = [
        'trackSubmit',
        'trackClick',
        'trackLink',
        'trackForm',
        'pageview',
        'identify',
        'reset',
        'group',
        'track',
        'ready',
        'alias',
        'debug',
        'page',
        'once',
        'off',
        'on',
        'addSourceMiddleware',
        'addIntegrationMiddleware',
        'setAnonymousId',
        'addDestinationMiddleware',
      ];
      analytics.factory = function (e: string) {
        return function (...args: any[]) {
          args.unshift(e);
          analytics.push(args);
          return analytics;
        };
      };
      for (let e = 0; e < analytics.methods.length; e++) {
        const t = analytics.methods[e];
        analytics[t] = analytics.factory(t);
      }
      analytics.load = function (e: string, t?: any) {
        const n = document.createElement('script');
        n.type = 'text/javascript';
        n.async = true;
        n.src = 'https://cdn.segment.com/analytics.js/v1/' + e + '/analytics.min.js';
        const a = document.getElementsByTagName('script')[0];
        a.parentNode.insertBefore(n, a);
        analytics._loadOptions = t;
      };
      analytics.SNIPPET_VERSION = '4.1.0';

      if (analyticsKey && btoa(analyticsKey) !== 'QU5BTFlUSUNTX0tFWQ==') {
        analytics.load(analyticsKey);
        analytics.page();
      }
    }
  }
} 